/**
 * @(#)SoftKey.js 1.0 2017/9/20.
 * @author
 * Copyright (c) 2017, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import Url from "./Url";
import Date from "./Date";
import Phone from "./Phone";
import EMail from "./EMail";
import Range from "./Range";
import Number from "./Number";
import String from "./String";
import Search from "./Search";
import YxRadio from "./YxRadio";
import Upload from "./YxUpload";
import Password from "./Password";
import YxSelect from "./YxSelect";
import YxSwitch from "./YxSwitch";
import TextArea from "./YxTextArea";
import Cascader from "./YxCascader";
import YxCheckbox from "./YxCheckbox";
import KindEditor from "./KindEditor";
import Certificates from "./Certificates";
import YxTreeSelect from "./YxTreeSelect";
import YxPopup from "./Popup";
import YxExtend from "./YxExtend";
import YxColorPicker from "./ColorPicker";
import YxCode from "./YxCode";

export default {
  Url,
  Date,
  EMail,
  Phone,
  Range,
  Number,
  Upload,
  Search,
  String,
  YxRadio,
  YxPopup,
  Cascader,
  YxSelect,
  YxSwitch,
  TextArea,
  Password,
  YxExtend,
  YxCheckbox,
  KindEditor,
  YxTreeSelect,
  Certificates,
  Radio: YxRadio,
  Select: YxSelect,
  YxColorPicker: YxColorPicker,
  YxCode,
};



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/index.js